import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { filter, take, timer } from 'rxjs';
import { GA_EVENTS, GA_PROPS, SOFT_SKILLS } from 'src/app/core/const.variables';
import { DashboardProxy } from 'src/app/core/store/dashboard/dashboard.proxy';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { HelperService } from 'src/app/core/services/helper.service';
import { RequirementLevel } from 'src/app/core/services/api.service';

@Component({
  selector: 'match-details-report',
  templateUrl: 'match-details-report.component.html',
  styleUrls: ['../match-details/match-details.component.scss']
})
export class MatchDetailsReportComponent implements OnInit {

  @Input() matchId = null;
  @Input() isVacancy = false;
  @Output() onClose = new EventEmitter<any>();
  @Input() leastFoundSkills = [];
  
  currentTab = 'info';
  talentAbout: string = null;
  matchScore = null;
  hardSkillsCommon = null;
  hardSkillsSimilar = null;
  softSkills = null;
  matchDetails = null;
  additionalData = null;
  private firstTabSwitch = false;

  constructor(
    private dashboardProxy: DashboardProxy,
    private gaService: GoogleAnalyticsService,
    private helperService: HelperService
  ) {
  }

  async ngOnInit() {
    let loadTime = 0;
    const timeSub = timer(0, 1).subscribe(time => loadTime = time)
    this.dashboardProxy.dropVacancyTalentDetails();

    await this.dashboardProxy.getMatchById(this.matchId);
    this.dashboardProxy.matchDetails$.pipe(filter(data => !!data), take(1)).subscribe(async matchDetails => {
      this.helperService.blockScroll$.next(true);
      this.matchDetails = matchDetails;
      this.matchScore = {
        totalMatch: matchDetails.totalMatch.toFixed(),
        hardSkillsMatch: matchDetails.hardSkillsMatch.toFixed(),
        softSkillsMatch: matchDetails.softSkillsMatch.toFixed()
      };
       const talentResult = await this.dashboardProxy.getTalentById(this.matchDetails.userId);
      const talent = (talentResult as any)?.payload;
       this.talentAbout = talent?.about?.objective ?? null;
       const talentHardSkills = talent?.hardSkills || [];
      this.hardSkillsCommon = this.prepareHardSkills(matchDetails.additionalInfo,talentHardSkills);
      this.hardSkillsSimilar = this.prepareHardSkills(matchDetails.additionalInfo, talentHardSkills,false);
      this.softSkills = this.prepareSoftSkills(matchDetails.additionalInfo);
      this.selectTab('info');
      timeSub.unsubscribe();
      this.gaService.gtag('event', GA_EVENTS.ShowMatchDetails, { 
        [GA_PROPS.LoadTime]: (loadTime / 1000).toFixed(2),
        [GA_PROPS.LoadTimeDim]: (loadTime / 1000).toFixed(2)
      });
    });
  }

  selectTab(param) {
    this.currentTab = param;
    if (this.currentTab === 'info' ) {
      this.firstTabSwitch = true;
      this.isVacancy ? this.dashboardProxy.getVacancyById(this.matchDetails.vacancyId) : this.dashboardProxy.getTalentById(this.matchDetails.userId);
      (this.isVacancy ? this.dashboardProxy.vacancyDetails$ : this.dashboardProxy.talentDetails$)
        .pipe(filter(data => !!data), take(1)).subscribe(data => {
          this.additionalData = data;
        });
    }
  }

  close() {
    this.helperService.blockScroll$.next(false);
    this.onClose.emit();
  }

  private prepareHardSkills(data, talentHardSkills, common = true) {
  if (data && data.detailedHardSkillsMatch?.length) {
    const toReturn = [];
    data.detailedHardSkillsMatch.forEach(branch => {
      if (branch.skills?.length) {
        const filteredSkills = branch.skills.filter(skill => common ? !skill.closeSkill : skill.closeSkill);

        if (filteredSkills.length) {
          const mappedSkills = filteredSkills.map(skill => {
            // find candidate’s skill
            const talentBranch = talentHardSkills.find(tb =>
              tb.name?.toLowerCase() === branch.name?.toLowerCase() ||
              tb.skills?.some(ts => ts.name?.toLowerCase() === skill.name?.toLowerCase())
            );

            const talentSkill = talentBranch?.skills?.find(ts =>
              ts.name?.toLowerCase() === skill.name?.toLowerCase()
            );

            return {
              ...skill,
              vacancyExp: skill.years ?? 0,
              talentExp: talentSkill?.years ?? 0,
              expertiseRequired: skill.experience ?? 0,
              talentExpertise: talentSkill?.experience ?? 0
            };
          });

          // Sort skills by skillMatch (high to low) and level of importance
          const sortedSkills = mappedSkills.sort((a, b) => {
            // First, sort by skillMatch (descending)
            if (b.skillMatch !== a.skillMatch) {
              return b.skillMatch - a.skillMatch;
            }

            // If skillMatch , sort by talentExpertise - level of importance(descending)
            return b.talentExpertise - a.talentExpertise;
          });

          toReturn.push({ ...branch, skills: sortedSkills });
        }
      }
    });

    // Sort branches by average skillMatch (descending)
    const sortedBranches = toReturn.sort((a, b) => {
      const avgMatchA = a.skills.reduce((sum, skill) => sum + skill.skillMatch, 0) / a.skills.length;
      const avgMatchB = b.skills.reduce((sum, skill) => sum + skill.skillMatch, 0) / b.skills.length;
      return avgMatchB - avgMatchA;
    });

    return sortedBranches.length ? sortedBranches : null;
  }
  return null;
}

  private prepareSoftSkills(data) {
    if (data && data.detailedSoftSkillsMatch && data.detailedSoftSkillsMatch.length) {
      return SOFT_SKILLS.map(item => ({
        ...item,
        skillMatch: data.detailedSoftSkillsMatch.find(val => item.name === val.name).skillMatch
      }));
    }
    return null;
  }

}
